import * as React from "react";
import {observer, inject} from "mobx-react";
import {observable} from "mobx";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Route, Link, Switch} from "react-router-dom";
import classnames from "classnames";

@inject("store")
@observer
export default class FilterToolBar extends React.Component {

    constructor(props) {
        super(props);
        this.handleFacetClick = this.handleFacetClick.bind(this);
        this.handleFilterClick = this.handleFilterClick.bind(this);
    }


    handleFacetClick(facetName, facetOptionValue) {
        const navigation = this.props.store.navigation;
        navigation.toggleFacetOption(facetName, facetOptionValue);
    }

    handleFilterClick() {
        const navigation = this.props.store.navigation;
        //navigation.toolbarRouter.push("/filter");
        navigation.openFilter()
    }


    render() {
        var selectedFacets = [];

        this.props.store.navigation.facets.filter(f => f.Name !== "CategoryIds" && f.Name !== "SubCategories").map(facet => {
            facet.FacetValues.filter(fo => fo.Selected).map(facetValue => {

                selectedFacets.push({
                    value: facetValue.Value,
                    label: facetValue.Value + '(' + facetValue.Count + ')',
                    count: facetValue.Count,
                    selected: facetValue.Selected,
                    facetName: facet.Name
                });
            });
        });
        { /*<div className={classnames("col-6 mobile-filter-toolbar", { "filter-toolbar--hidden": !this.state.visible })}>*/
        }
        return (
            <div className="col-6 mobile-filter-toolbar">
                <div className={"filter-icon" + (selectedFacets.length > 0 ? ' bold' : '')} onClick={() => {
                    this.handleFilterClick();
                }}>

                    {"Filter" || this.props.store.navigation.dictionary.Filter}
                    {selectedFacets.length > 0 ? " (" + selectedFacets.length + ")" : ""}
                </div>
            </div>
        );
    }
}


